import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {fetchWrapper } from './../_helpers';

// create slice
const name = 'users';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({ name, initialState,reducers, extraReducers });

// exports

export const userActions = { ...slice.actions, ...extraActions };
export const userReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        user:{},
        users: [],
        error: null,
         isLoading:false,
        userResponse: [],
        deleteUserResponse:[],
        settingResponse:{},
        messageUserList:[],
        messageList:[],
        sendMessageResponse:{},
        resetPassword:{},
    }
}

function createReducers() {
    return {
        clearUserResponse,
        tempUpdateSetting,
    };

    function clearUserResponse(state) {
        state.userResponse = [];
        state.deleteUserResponse= [];
    }
    function tempUpdateSetting(state, action) {
        
        state.settingResponse =  action?.payload;
      }
}

function createExtraActions() {
     const baseUrl = `${process.env.REACT_APP_API_URL}/User`;
     const baseUrl2 = `${process.env.REACT_APP_API_URL}/QuickBookApi`;
     
    return {
        getUserAll: getUserAll(),
        getUserById:getUserById(),
        getUserMailId:getUserMailId(),
        saveUser: saveUser(),
        deleteUser: deleteUser(),
        getSettingAndCheckRefreshToken:getSettingAndCheckRefreshToken(),
        getMessageUserList:getMessageUserList(),
        getAndUpdateMessageList:getAndUpdateMessageList(),
        sendMessage:sendMessage()
      
    };

    function getUserAll() {
        return createAsyncThunk(
            `${name}/getUserAll`,
            async ({ CurrentUserID }) => await fetchWrapper.get(`${baseUrl}/GetUserDetails?CurrentUserID=${CurrentUserID}`)
        );
    }
     function getUserById() {
        return createAsyncThunk(
            `${name}/getUserById`,
             async (UserDetail) => await fetchWrapper.get(`${baseUrl}/GetUserDetails?UserID=${UserDetail.UserID}&CurrentUserID=${UserDetail.CurrentUserID}`)
        );
    }

function getUserMailId () {
    return createAsyncThunk(
        `${name}/getUserMailId`,
        async (UserDetail) => await fetchWrapper.post(`${baseUrl}/UserPasswordUpdate`, UserDetail )
    );
    }

    function saveUser() {
        return createAsyncThunk(
            `${name}/saveUser`,
             async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateUser`, addFormData )
        );
    }

    function deleteUser()
    {
        return createAsyncThunk(
            `${name}/deleteUser`,
             async (UserDetail) => await fetchWrapper.post(`${baseUrl}/DeleteUser?UserID=${UserDetail.UserID}&DeletedBy=${UserDetail.DeletedBy}`)
          
        );
    }
    function getSettingAndCheckRefreshToken() {
        return createAsyncThunk(
            `${name}/getSettingAndCheckRefreshToken`,
            async () => await fetchWrapper.get(`${baseUrl2}/GetSettingAndCheckRefreshToken`)
        );
    }
    function getMessageUserList() {
        return createAsyncThunk(
            `${name}/getMessageUserList`,
             async (UserDetail) => await fetchWrapper.get(`${baseUrl}/GetMessageUserList?UserID=${UserDetail.UserID}`)
        );
    }

    function getAndUpdateMessageList() {
        return createAsyncThunk(
            `${name}/getAndUpdateMessageList`,
             async (Message) => await fetchWrapper.get(`${baseUrl}/GetAndUpdateMessageList?SenderID=${Message.SenderID}&ReceiverID=${Message.ReceiverID}`)
        );
    }

    function sendMessage() {
        return createAsyncThunk(
            `${name}/sendMessage`,
             async (Message) => await fetchWrapper.get(`${baseUrl}/SendMessage?Message=${Message.messageText} &SenderID=${Message.senderId}&ReceiverID=${Message.receiverId}`)
        );
    }
    
}


function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getUserAll.pending, (state) => { //getUserAll
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getUserAll.fulfilled, (state, action) => {
            state.isLoading = true;
            state.userResponse = [];
            state.deleteUserResponse = [];
            state.users = action.payload || [];
        })
        .addCase(extraActions.getUserAll.rejected, (state, action) => {
            state.isLoading = true;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getUserById.pending, (state) => { //getUserById
            state.user = { loading: true };
        })
        .addCase(extraActions.getUserById.fulfilled, (state, action) => {
            state.user = action.payload && action.payload[0];
            state.userResponse = [];
            state.deleteUserResponse = [];
        })
        .addCase(extraActions.getUserById.rejected, (state, action) => {
            state.user = { error: action.error };
        })
        .addCase(extraActions.saveUser.pending, (state) => {  //saveUser
            state.userResponse = { loading: true };
        })
        .addCase(extraActions.saveUser.fulfilled, (state, action) => {
            state.userResponse = action.payload;
            state.deleteUserResponse = [];
        })
        .addCase(extraActions.saveUser.rejected, (state, action) => {
            state.userResponse = { error: action.error };
        })
        .addCase(extraActions.deleteUser.pending, (state) => {  //deleteUser
            state.deleteUserResponse = { loading: true };
        })
        .addCase(extraActions.deleteUser.fulfilled, (state, action) => {
            state.deleteUserResponse = action.payload;
            state.userResponse = [];
        })
        .addCase(extraActions.deleteUser.rejected, (state, action) => {
            state.deleteUserResponse = { error: action.error };
        })
        .addCase(extraActions.getSettingAndCheckRefreshToken.pending, (state) => { //getSettingAndCheckRefreshToken
            state.settingResponse = { loading: true };
        })
        .addCase(extraActions.getSettingAndCheckRefreshToken.fulfilled, (state, action) => {
            state.settingResponse = action.payload;
        })
        .addCase(extraActions.getSettingAndCheckRefreshToken.rejected, (state, action) => {
            state.settingResponse = { error: action.error };
        })
        .addCase(extraActions.getMessageUserList.pending, (state) => { // getMessageUserList
            state.messageUserList = [];
        })
        .addCase(extraActions.getMessageUserList.fulfilled, (state, action) => {
            state.messageUserList = action.payload?.Item1 || [];
        })
        .addCase(extraActions.getMessageUserList.rejected, (state) => {
            state.messageUserList = [];
        })
        .addCase(extraActions.getAndUpdateMessageList.pending, (state) => { // getAndUpdateMessageList
            state.messageList = [];
        })
        .addCase(extraActions.getAndUpdateMessageList.fulfilled, (state, action) => {
            state.messageList = action.payload?.MessageList || [];
        })
        .addCase(extraActions.getAndUpdateMessageList.rejected, (state) => {
            state.messageList = [];
        })
        .addCase(extraActions.sendMessage.pending, (state, action) => {  //sendMessage
            const { messageText, senderId, receiverId } = action.meta.arg;
            const lastMessage = {
                MessageID: 0,
                MessageText: messageText,
                SenderID: senderId,
                ReceiverID: receiverId,
                CreatedDate: new Date().toISOString(),
            };
            state.messageList = [...state.messageList, lastMessage];
            state.sendMessageResponse = [];
        })
        .addCase(extraActions.sendMessage.fulfilled, (state, action) => {
            state.messageList = action.payload?.MessageList || [];
        })
        .addCase(extraActions.sendMessage.rejected, (state) => {
            state.sendMessageResponse = [];
        })
        .addCase(extraActions.getUserMailId.pending,(state)=>{

            state.resetPassword ={ loading: true}
        })
        .addCase(extraActions.getUserMailId.fulfilled,(state, action)=>{
            
            state.resetPassword = action.payload
        })
        .addCase(extraActions.getUserMailId.rejected,(state,action)=>{
            state.resetPassword ={ error: action.error}
        });
}

